<template>
  <div class="sceneryDetail">
    <!-- 轮播图 -->
    <van-swipe height="300" @change="onChange">
      <van-swipe-item
        v-for="(image, index) in sceneryDetail.imgList"
        :key="index"
      >
        <img :src="image.path" class="banner-img" />
      </van-swipe-item>
      <template #indicator>
        <div
          class="custom-indicator"
          v-if="sceneryDetail && sceneryDetail.imgList"
        >
          {{ currentIndic + 1 }}/{{ sceneryDetail.imgList.length }}
        </div>
      </template>
    </van-swipe>
    <!-- 内容 -->
    <div class="food-info">
      <p class="title">{{ sceneryDetail.title }}</p>
      <div class="tags" v-if="sceneryDetail.tagsStr">
        <span
          :class="['tag', index !== 0 && 'tag-left']"
          v-for="(tag, index) in sceneryDetail.tagsStr.split('，')"
          :key="index"
          >{{ tag }}</span
        >
      </div>
      <div class="location">
        <img
          src="@/assets/images/icon_zuobiao_dgray.png"
          class="location-img"
        />
        <p class="location-text">{{ sceneryDetail.address }}</p>
      </div>
    </div>
    <!-- 简介 -->
    <div class="intro">
      <p class="intro-title">景点简介</p>
      <p class="intro-con" v-if="sceneryDetail && sceneryDetail.context">
        {{
          isShowMore
            ? sceneryDetail.context
            : `${sceneryDetail.context.slice(0, 50)}...`
        }}
      </p>
      <div class="get-more">
        <div class="more" @click="showMore">
          <span class="more-text">{{ isShowMore ? '收起' : '查看更多' }}</span>
          <img
            src="@/assets/images/icon_up.png"
            v-if="isShowMore"
            class="icon"
          />
          <img src="@/assets/images/icon_down.png" v-else class="icon" />
        </div>
      </div>
    </div>
    <!-- 评论 -->
    <comment-list type="scenery" :addParams="params" />
    <open-app />
  </div>
</template>

<script>
import { getSceneryDetail } from '@/service/api'
import CommentList from '@/components/CommentList.vue'
import { getUrlParams } from '@/utils'
import OpenApp from '@/components/OpenApp.vue'
export default {
  components: { CommentList, OpenApp },
  data() {
    return {
      sceneryDetail: {},
      currentIndic: 0,
      isShowMore: false,
      //
      params: {
        sceneryId: '',
      },
    }
  },
  created() {
    this.params.sceneryId = getUrlParams('sceneryId')
  },
  mounted() {
    this._getSceneryDetail()
  },
  methods: {
    onChange(index) {
      this.currentIndic = index
    },
    showMore() {
      this.isShowMore = !this.isShowMore
    },
    //获取美食详情
    async _getSceneryDetail() {
      // const id = '02734a70a8d832a0a62b6dfddfbde305'
      const id = getUrlParams('sceneryId')
      try {
        const res = await getSceneryDetail(id)
        if (res) {
          // console.log('----景点详情---', res)
          this.sceneryDetail = res
        }
      } catch (error) {
        this.$toast(`${error}`)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.sceneryDetail {
  width: 100%;
  // padding-bottom: 70px;
  .banner-img {
    width: 100%;
    height: 100%;
  }
  //banner指示器
  .custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 4px 10px;
    font-size: 12px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
  }
  .food-info {
    padding: 10px 15px;
    .title {
      font-size: 22px;
      font-weight: 600;
      margin-top: 10px;
    }
    //标签
    .tags {
      margin-top: 10px;
      font-size: 0;
      .tag {
        font-size: 12px;
        color: #f17c25;
        background-color: #fdf5e6;
        padding: 2px 5px;
        border-radius: 2px;
      }
      .tag-left {
        margin-left: 10px;
      }
    }
    //位置
    .location {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .location-img {
        width: 14px;
        height: 14px;
      }
      .location-text {
        flex: 1;
        font-size: 12px;
        padding-left: 5px;
      }
    }
    //.intro
  }
  .intro {
    margin-top: 6px;
    border-top: 10px solid #f8f8f8;
    padding: 10px 15px;
    .intro-title {
      font-size: 16px;
      font-weight: 600;
    }
    .intro-con {
      font-size: 14px;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .get-more {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      .more {
        background-color: #eee;
        padding: 3px 8px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        .more-text {
          font-size: 12px;
          color: #0997f7;
        }
        .icon {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
}
</style>
